export const GET_PROTOCOL = '[utm get protocol]'
export const GET_LINK_PAGE = '[utm get link page]'
export const GET_SOURCE_TRAFFIC = '[utm get source traffic]'
export const GET_PARAMETERS = '[utm get parameters]'
export const GET_TRANSLITERATION = '[utm get transliteration]'
export const GET_LOADING_SHORT_LINK = '[utm loading short link]'
export const GET_SHORT_LINK = '[utm get short link]'
export const ERROR_SHORT_LINK = '[utm error short link]'
